import React from 'react';
import Proptype from 'prop-types';
import { GroupContainer, Button, Label } from './style';

export const ButtonGroup = ({ buttons }) => {
    const renderButtons = buttons.map(({ label, isActive, onClick }, idx) => (
        <Button
            isActive={isActive}
            groupLength={buttons.length}
            tabindex="0"
            type="button"
            data-testid="button-group-item"
            key={idx}
            onClick={onClick}>
            <Label>{label}</Label>
        </Button>
    ));

    return (
        <GroupContainer role="group" aria-label="button group">
           {renderButtons}
        </GroupContainer>
    );
};

ButtonGroup.propTypes = {
    buttons: Proptype.arrayOf(Proptype.shape({
        label: Proptype.string.isRequired,
        isActive: Proptype.bool.isRequired,
        onClick: Proptype.func.isRequired
    })).isRequired
};
export default ButtonGroup;
